<template>
  <div class="flex flex-col min-h-screen">
    <div>
      <NavMain @showRightNav="showRightNav" />
    </div>

    <div
      class="grid grid-cols-6 sm:grid-cols-6 md:grid-cols-6 lg:grid-cols-6 xl:grid-cols-6"
    >
      <div
        class="hidden sm:hidden md:hidden lg:grid xl:grid lg:col-span-2 xl:col-span-2"
      ></div>
      <div
        class="col-span-6 lg:grid xl:grid lg:col-span-2 xl:col-span-2 mt-0 sm:mt-0 md:mt-0 lg:mt-4 xl:mt-4 mx-0 sm:mx-0 md:mx-0 lg:mx-2 xl:mx-2 items-center"
      >
        <p class="text-2xl font-opensans font-semibold text-mi-blue-500">
          Ohoh... pagina niet gevonden.
        </p>
        <img src="../../assets/bal.jpg" />
        <p class="text-center font-opensans">Kun jij de bal wél vinden?</p>
      </div>

      <div
        class="hidden sm:hidden md:hidden lg:grid xl:grid lg:col-span-2 xl:col-span-2"
      ></div>
    </div>

    <div class="flex flex-grow">
      <Footer />
    </div>
  </div>
</template>

<script>
import NavMain from "../NavMain";
import Footer from "../Footer";
export default {
  name: "NotFound",
  components: {
    NavMain,
    Footer,
  },
};
</script>

<style>
</style>